import React from 'react';
import css from './SetBudget.module.css';

const ErrorField = ({ children }) => {
  if (!children) return null;
  return <p className={css.error}>{children}</p>;
};

export default React.memo(ErrorField);
